
define('underscore-extensions',['require','_underscore'],function (require) {
    'use strict';

    var _ = require('_underscore');
    
    // Note: the contents of this file should be carefully curated. They will be loaded with all instances of underscore.
    
    //#region Utility Functions

    // purely sugar here - reads much better though; you don't have the double negative
    _.isDefined = function (val) {
        ///<summary>The inverse of _.isUndefined(). Purely for readability, removing the double negative.</summary>
        return val !== undefined;
    };

    _.exists = function (val) {
        ///<summary>Returns true iff the given value exists, i.e., if it is not null or undefined, but can be zero, empty string, or false.</summary>
        return val !== null && val !== undefined;
    };

    //#endregion


    //#region Collection/Array Functions
    
    _.mixin({
        // Note: use cases of this that only use a keySelector (and no valueSelector) can use the newer (built-in) _.indexBy() method
        hash: function (source, keySelector, valueSelector) {
            /// <summary>
            /// Create a hash from a collection (similar to IEnumerable.ToDictionary() in C#). 
            /// Each item is hashed as a key/value pair using the provided selector functions.
            /// If a string is passed for a selector function, the corresponding property will be plucked from the object.
            /// If no functions are provided, each object and it's iterative key will be used as the value and key, respectively.
            /// </summary>


            function getSelector(func) {
                return _.isString(func) ? function (object) {
                    return object[func];
                } : func;
            }

            keySelector = getSelector(keySelector || function (val, key) {
                return key;
            });
            valueSelector = getSelector(valueSelector || _.identity);

            var hash = { };
            _.each(source, function (val, key) {
                hash[keySelector(val, key, source)] = valueSelector(val, key, source);
            });
            return hash;
        },

        transpose: function (arrays) {
            ///<summary>Treats the arrays as a matrix and returns its transpose.</summary>
            
            return _.zip.apply(null, arrays);
        },

        cloneMany: function (obj, numberOfClones) {
            ///<summary>Create multiple identical clones of an object.</summary>
            var clones = [];
            for (var i = 0; i < numberOfClones; i++) {
                clones.push(_.clone(obj));
            }
            return clones;
        }
    });
    
    //#endregion

    return _;
});
